// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fea026ae","455":"f299000d","977":"aa74253f"}[chunkId] + ".chunk.js";
};